import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const MaterialStatusList = Loadable(lazy(() => import("features/materialStatus/components/List")));
const MaterialStatusPage = Loadable(lazy(() => import("features/materialStatus/components/Page")));

const routes = {
  path: "materialStatus",
  children: [
    { path: "", element: <MaterialStatusList /> },
    { path: "add", element: <MaterialStatusPage /> },
    { path: "edit/:materialStatusID?", element: <MaterialStatusPage /> },
  ],
};

export default routes;
